/**
 * Mock Users Data
 * Complete user objects for all usernames used in table mocks
 * Provides consistent user data across the application including:
 * - Basic info (id, username, email)
 * - Profile data (avatarUrl, bio, joinedAt)
 * - Stats and preferences
 */

export const mockUsers = {
  // Table 1: Veterans Table
  joão: {
    id: "user_joao",
    username: "João",
    email: "joao@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=joao",
    bio: "Veteran Guild for Glory player.",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 365).toISOString(), // 1 year ago
    status: "online",
    stats: {
      gamesPlayed: 150,
      gamesWon: 78,
      favoriteCharacter: 1,
    },
    preferences: {
      language: "pt-BR",
      theme: "dark",
    },
  },

  maria: {
    id: "user_maria",
    username: "Maria",
    email: "maria@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=maria",
    bio: "Estrategista dedicada, adora desafios difíceis!",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 200).toISOString(),
    status: "online",
    stats: {
      gamesPlayed: 95,
      gamesWon: 52,
      favoriteCharacter: 6,
    },
    preferences: {
      language: "pt-BR",
      theme: "light",
    },
  },

  pedro: {
    id: "user_pedro",
    username: "Pedro",
    email: "pedro@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=pedro",
    bio: "Casual player who loves cooperative quests.",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 180).toISOString(),
    status: "online",
    stats: {
      gamesPlayed: 67,
      gamesWon: 34,
      favoriteCharacter: 2,
    },
    preferences: {
      language: "pt-BR",
      theme: "dark",
    },
  },

  // Table 2: Epic Adventure
  ana: {
    id: "user_ana",
    username: "Ana",
    email: "ana@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=ana",
    bio: "Exploradora corajosa em busca de aventuras épicas!",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 120).toISOString(),
    status: "online",
    stats: {
      gamesPlayed: 45,
      gamesWon: 23,
      favoriteCharacter: 6,
    },
    preferences: {
      language: "en-US",
      theme: "dark",
    },
  },

  carlos: {
    id: "user_carlos",
    username: "Carlos",
    email: "carlos@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=carlos",
    bio: "Sempre procurando melhorar minhas estratégias.",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 90).toISOString(),
    status: "online",
    stats: {
      gamesPlayed: 38,
      gamesWon: 19,
      favoriteCharacter: 6,
    },
    preferences: {
      language: "es-ES",
      theme: "light",
    },
  },

  // Table 3: Dragon Battle
  lucas: {
    id: "user_lucas",
    username: "Lucas",
    email: "lucas@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=lucas",
    bio: "Caçador de dragões e líder nato!",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 240).toISOString(),
    status: "online",
    stats: {
      gamesPlayed: 112,
      gamesWon: 67,
      favoriteCharacter: 1,
    },
    preferences: {
      language: "en-US",
      theme: "dark",
    },
  },

  fernanda: {
    id: "user_fernanda",
    username: "Fernanda",
    email: "fernanda@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=fernanda",
    bio: "Powerful mage focused on strategic spellcasting.",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 160).toISOString(),
    status: "online",
    stats: {
      gamesPlayed: 88,
      gamesWon: 45,
      favoriteCharacter: 6,
    },
    preferences: {
      language: "pt-BR",
      theme: "dark",
    },
  },

  ricardo: {
    id: "user_ricardo",
    username: "Ricardo",
    email: "ricardo@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=ricardo",
    bio: "Competitive player always seeking improvement.",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 200).toISOString(),
    status: "online",
    stats: {
      gamesPlayed: 134,
      gamesWon: 89,
      favoriteCharacter: 3,
    },
    preferences: {
      language: "pt-BR",
      theme: "light",
    },
  },

  paula: {
    id: "user_paula",
    username: "Paula",
    email: "paula@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=paula",
    bio: "Estrategista criativa e jogadora social.",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 140).toISOString(),
    status: "online",
    stats: {
      gamesPlayed: 73,
      gamesWon: 38,
      favoriteCharacter: 6,
    },
    preferences: {
      language: "en-US",
      theme: "dark",
    },
  },

  // Table 4-11 Players (simplified for brevity, but complete)
  player1: {
    id: "user_player1",
    username: "Player1",
    email: "player1@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=player1",
    bio: "Ready to play!",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 50).toISOString(),
    status: "online",
    stats: { gamesPlayed: 25, gamesWon: 12 },
    preferences: { language: "en-US", theme: "dark" },
  },

  player2: {
    id: "user_player2",
    username: "Player2",
    email: "player2@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=player2",
    bio: "Casual gamer enjoying the adventure.",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 45).toISOString(),
    status: "online",
    stats: { gamesPlayed: 30, gamesWon: 15 },
    preferences: { language: "en-US", theme: "light" },
  },

  player3: {
    id: "user_player3",
    username: "Player3",
    email: "player3@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=player3",
    bio: "Learning the ropes!",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 30).toISOString(),
    status: "online",
    stats: { gamesPlayed: 18, gamesWon: 8 },
    preferences: { language: "en-US", theme: "dark" },
  },

  player4: {
    id: "user_player4",
    username: "Player4",
    email: "player4@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=player4",
    bio: "Strategy enthusiast.",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 60).toISOString(),
    status: "online",
    stats: { gamesPlayed: 42, gamesWon: 21 },
    preferences: { language: "es-ES", theme: "dark" },
  },

  player5: {
    id: "user_player5",
    username: "Player5",
    email: "player5@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=player5",
    bio: "Always ready for a challenge!",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 55).toISOString(),
    status: "online",
    stats: { gamesPlayed: 36, gamesWon: 18 },
    preferences: { language: "fr-FR", theme: "light" },
  },

  player6: {
    id: "user_player6",
    username: "Player6",
    email: "player6@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=player6",
    bio: "Team player and collaborator.",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 40).toISOString(),
    status: "online",
    stats: { gamesPlayed: 28, gamesWon: 14 },
    preferences: { language: "pt-BR", theme: "dark" },
  },

  hostplayer: {
    id: "user_hostplayer",
    username: "HostPlayer",
    email: "host@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=host",
    bio: "I create welcoming tables for all players.",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 300).toISOString(),
    status: "online",
    stats: { gamesPlayed: 156, gamesWon: 82 },
    preferences: { language: "en-US", theme: "light" },
  },

  // Table 6: Hardcore Private Campaign
  elite1: {
    id: "user_elite1",
    username: "Elite1",
    email: "elite1@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=elite1",
    bio: "Hardcore player seeking ultimate challenges!",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 400).toISOString(),
    status: "online",
    stats: { gamesPlayed: 245, gamesWon: 178 },
    preferences: { language: "pt-BR", theme: "dark" },
  },

  elite2: {
    id: "user_elite2",
    username: "Elite2",
    email: "elite2@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=elite2",
    bio: "Pro gamer and strategist.",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 380).toISOString(),
    status: "online",
    stats: { gamesPlayed: 223, gamesWon: 156 },
    preferences: { language: "en-US", theme: "dark" },
  },

  elite3: {
    id: "user_elite3",
    username: "Elite3",
    email: "elite3@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=elite3",
    bio: "Competitive player with extensive campaign experience.",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 360).toISOString(),
    status: "online",
    stats: { gamesPlayed: 198, gamesWon: 134 },
    preferences: { language: "pt-BR", theme: "dark" },
  },

  // Table 7: Completed Journey
  winner1: {
    id: "user_winner1",
    username: "Winner1",
    email: "winner1@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=winner1",
    bio: "Champion of multiple campaigns!",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 280).toISOString(),
    status: "online",
    stats: { gamesPlayed: 167, gamesWon: 98 },
    preferences: { language: "fr-FR", theme: "light" },
  },

  winner2: {
    id: "user_winner2",
    username: "Winner2",
    email: "winner2@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=winner2",
    bio: "Victory is my middle name!",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 260).toISOString(),
    status: "online",
    stats: { gamesPlayed: 145, gamesWon: 87 },
    preferences: { language: "en-US", theme: "dark" },
  },

  winner3: {
    id: "user_winner3",
    username: "Winner3",
    email: "winner3@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=winner3",
    bio: "Strategic mastermind.",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 240).toISOString(),
    status: "online",
    stats: { gamesPlayed: 134, gamesWon: 76 },
    preferences: { language: "pt-BR", theme: "dark" },
  },

  winner4: {
    id: "user_winner4",
    username: "Winner4",
    email: "winner4@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=winner4",
    bio: "Skilled player with a winning streak!",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 220).toISOString(),
    status: "online",
    stats: { gamesPlayed: 128, gamesWon: 72 },
    preferences: { language: "es-ES", theme: "light" },
  },

  // Table 8: Last Spot Available
  p1: {
    id: "user_p1",
    username: "P1",
    email: "p1@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=p1",
    bio: "Quick player, fast decisions!",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 70).toISOString(),
    status: "online",
    stats: { gamesPlayed: 56, gamesWon: 28 },
    preferences: { language: "en-US", theme: "dark" },
  },

  p2: {
    id: "user_p2",
    username: "P2",
    email: "p2@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=p2",
    bio: "Tactical thinker.",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 65).toISOString(),
    status: "online",
    stats: { gamesPlayed: 48, gamesWon: 24 },
    preferences: { language: "en-US", theme: "light" },
  },

  p3: {
    id: "user_p3",
    username: "P3",
    email: "p3@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=p3",
    bio: "Friendly player!",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 60).toISOString(),
    status: "online",
    stats: { gamesPlayed: 42, gamesWon: 21 },
    preferences: { language: "pt-BR", theme: "dark" },
  },

  p4: {
    id: "user_p4",
    username: "P4",
    email: "p4@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=p4",
    bio: "Loves a good challenge!",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 55).toISOString(),
    status: "online",
    stats: { gamesPlayed: 38, gamesWon: 19 },
    preferences: { language: "es-ES", theme: "dark" },
  },

  p5: {
    id: "user_p5",
    username: "P5",
    email: "p5@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=p5",
    bio: "Experienced player.",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 80).toISOString(),
    status: "online",
    stats: { gamesPlayed: 64, gamesWon: 32 },
    preferences: { language: "en-US", theme: "light" },
  },

  // Table 9: Duelo 1v1
  duelist1: {
    id: "user_duelist1",
    username: "Duelist1",
    email: "duelist1@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=duelist1",
    bio: "1v1 specialist, bring it on!",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 180).toISOString(),
    status: "online",
    stats: { gamesPlayed: 89, gamesWon: 56 },
    preferences: { language: "pt-BR", theme: "dark" },
  },

  duelist2: {
    id: "user_duelist2",
    username: "Duelist2",
    email: "duelist2@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=duelist2",
    bio: "Head-to-head combat expert.",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 170).toISOString(),
    status: "online",
    stats: { gamesPlayed: 82, gamesWon: 48 },
    preferences: { language: "pt-BR", theme: "light" },
  },

  // Table 10: Mega Raid Boss
  raider1: {
    id: "user_raider1",
    username: "Raider1",
    email: "raider1@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=raider1",
    bio: "Raid leader and coordinator!",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 320).toISOString(),
    status: "online",
    stats: { gamesPlayed: 189, gamesWon: 112 },
    preferences: { language: "zh-CN", theme: "dark" },
  },

  raider2: {
    id: "user_raider2",
    username: "Raider2",
    email: "raider2@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=raider2",
    bio: "Tank specialist.",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 310).toISOString(),
    status: "online",
    stats: { gamesPlayed: 176, gamesWon: 98 },
    preferences: { language: "zh-CN", theme: "dark" },
  },

  raider3: {
    id: "user_raider3",
    username: "Raider3",
    email: "raider3@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=raider3",
    bio: "DPS focused player.",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 300).toISOString(),
    status: "online",
    stats: { gamesPlayed: 164, gamesWon: 89 },
    preferences: { language: "zh-CN", theme: "light" },
  },

  raider4: {
    id: "user_raider4",
    username: "Raider4",
    email: "raider4@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=raider4",
    bio: "Support role expert.",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 290).toISOString(),
    status: "online",
    stats: { gamesPlayed: 158, gamesWon: 84 },
    preferences: { language: "zh-CN", theme: "dark" },
  },

  raider5: {
    id: "user_raider5",
    username: "Raider5",
    email: "raider5@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=raider5",
    bio: "Versatile player.",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 280).toISOString(),
    status: "online",
    stats: { gamesPlayed: 142, gamesWon: 76 },
    preferences: { language: "zh-CN", theme: "dark" },
  },

  raider6: {
    id: "user_raider6",
    username: "Raider6",
    email: "raider6@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=raider6",
    bio: "Strategic player.",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 270).toISOString(),
    status: "online",
    stats: { gamesPlayed: 136, gamesWon: 68 },
    preferences: { language: "zh-CN", theme: "light" },
  },

  raider7: {
    id: "user_raider7",
    username: "Raider7",
    email: "raider7@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=raider7",
    bio: "Team player.",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 260).toISOString(),
    status: "online",
    stats: { gamesPlayed: 124, gamesWon: 62 },
    preferences: { language: "zh-CN", theme: "dark" },
  },

  raider8: {
    id: "user_raider8",
    username: "Raider8",
    email: "raider8@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=raider8",
    bio: "Raid enthusiast!",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 250).toISOString(),
    status: "online",
    stats: { gamesPlayed: 118, gamesWon: 59 },
    preferences: { language: "zh-CN", theme: "light" },
  },

  // Table 11: Paused Table
  activeplayer1: {
    id: "user_activeplayer1",
    username: "ActivePlayer1",
    email: "activeplayer1@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=activeplayer1",
    bio: "Active and engaged player.",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 100).toISOString(),
    status: "online",
    stats: { gamesPlayed: 72, gamesWon: 36 },
    preferences: { language: "es-ES", theme: "dark" },
  },

  activeplayer2: {
    id: "user_activeplayer2",
    username: "ActivePlayer2",
    email: "activeplayer2@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=activeplayer2",
    bio: "Consistent player.",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 95).toISOString(),
    status: "online",
    stats: { gamesPlayed: 68, gamesWon: 34 },
    preferences: { language: "es-ES", theme: "light" },
  },

  activeplayer3: {
    id: "user_activeplayer3",
    username: "ActivePlayer3",
    email: "activeplayer3@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=activeplayer3",
    bio: "Reliable teammate.",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 90).toISOString(),
    status: "online",
    stats: { gamesPlayed: 64, gamesWon: 32 },
    preferences: { language: "es-ES", theme: "dark" },
  },

  // Table 12: VIP Waiting Room
  organizadorhost: {
    id: "user_organizadorhost",
    username: "OrganizadorHost",
    email: "organizador@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=organizador",
    bio: "Event organizer and game master. Creating amazing experiences!",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 500).toISOString(),
    status: "online",
    stats: { gamesPlayed: 289, gamesWon: 156 },
    preferences: { language: "en-US", theme: "light" },
  },

  // Spectators
  earlybird1: {
    id: "user_earlybird1",
    username: "EarlyBird1",
    email: "earlybird1@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=earlybird1",
    bio: "Always first to join, love watching strategies unfold!",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 45).toISOString(),
    status: "online",
    stats: { gamesPlayed: 12, gamesWon: 5 },
    preferences: { language: "en-US", theme: "dark" },
  },

  earlybird2: {
    id: "user_earlybird2",
    username: "EarlyBird2",
    email: "earlybird2@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=earlybird2",
    bio: "Spectator mode is my favorite! Learning from the best.",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 40).toISOString(),
    status: "online",
    stats: { gamesPlayed: 8, gamesWon: 3 },
    preferences: { language: "en-US", theme: "light" },
  },

  visitante1: {
    id: "user_visitante1",
    username: "Visitante1",
    email: "visitante1@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=visitante1",
    bio: "Curious visitor watching the games!",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 20).toISOString(),
    status: "online",
    stats: { gamesPlayed: 5, gamesWon: 2 },
    preferences: { language: "pt-BR", theme: "dark" },
  },

  observador1: {
    id: "user_observador1",
    username: "Observador1",
    email: "observador1@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=observador1",
    bio: "Observer learning the game mechanics.",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 35).toISOString(),
    status: "online",
    stats: { gamesPlayed: 10, gamesWon: 4 },
    preferences: { language: "en-US", theme: "light" },
  },

  observador2: {
    id: "user_observador2",
    username: "Observador2",
    email: "observador2@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=observador2",
    bio: "Spectating to improve my skills!",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 30).toISOString(),
    status: "online",
    stats: { gamesPlayed: 15, gamesWon: 7 },
    preferences: { language: "en-US", theme: "dark" },
  },

  fan1: {
    id: "user_fan1",
    username: "Fan1",
    email: "fan1@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=fan1",
    bio: "Huge fan of Guild for Glory!",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 25).toISOString(),
    status: "online",
    stats: { gamesPlayed: 6, gamesWon: 2 },
    preferences: { language: "fr-FR", theme: "light" },
  },

  fan2: {
    id: "user_fan2",
    username: "Fan2",
    email: "fan2@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=fan2",
    bio: "Spectating is fun!",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 22).toISOString(),
    status: "online",
    stats: { gamesPlayed: 7, gamesWon: 3 },
    preferences: { language: "zh-CN", theme: "dark" },
  },

  fan3: {
    id: "user_fan3",
    username: "Fan3",
    email: "fan3@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=fan3",
    bio: "Learning by watching pros!",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 20).toISOString(),
    status: "online",
    stats: { gamesPlayed: 4, gamesWon: 1 },
    preferences: { language: "zh-CN", theme: "light" },
  },

  fan4: {
    id: "user_fan4",
    username: "Fan4",
    email: "fan4@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=fan4",
    bio: "Casual observer.",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 18).toISOString(),
    status: "online",
    stats: { gamesPlayed: 3, gamesWon: 1 },
    preferences: { language: "zh-CN", theme: "dark" },
  },

  fan5: {
    id: "user_fan5",
    username: "Fan5",
    email: "fan5@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=fan5",
    bio: "Enjoying the show!",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 15).toISOString(),
    status: "online",
    stats: { gamesPlayed: 2, gamesWon: 0 },
    preferences: { language: "zh-CN", theme: "light" },
  },

  spec1: {
    id: "user_spec1",
    username: "Spec1",
    email: "spec1@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=spec1",
    bio: "Spectator and learner.",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 28).toISOString(),
    status: "online",
    stats: { gamesPlayed: 9, gamesWon: 4 },
    preferences: { language: "en-US", theme: "dark" },
  },

  spec2: {
    id: "user_spec2",
    username: "Spec2",
    email: "spec2@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=spec2",
    bio: "Watching and learning strategies.",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 26).toISOString(),
    status: "online",
    stats: { gamesPlayed: 11, gamesWon: 5 },
    preferences: { language: "en-US", theme: "light" },
  },

  spec3: {
    id: "user_spec3",
    username: "Spec3",
    email: "spec3@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=spec3",
    bio: "Observer mode enthusiast.",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 24).toISOString(),
    status: "online",
    stats: { gamesPlayed: 8, gamesWon: 3 },
    preferences: { language: "en-US", theme: "dark" },
  },

  waitingspec: {
    id: "user_waitingspec",
    username: "WaitingSpec",
    email: "waitingspec@guildforglory.com",
    avatarUrl: "https://api.dicebear.com/7.x/avataaars/svg?seed=waitingspec",
    bio: "Patiently waiting and watching!",
    joinedAt: new Date(Date.now() - 1000 * 60 * 60 * 24 * 12).toISOString(),
    status: "online",
    stats: { gamesPlayed: 4, gamesWon: 1 },
    preferences: { language: "es-ES", theme: "light" },
  },
};

/**
 * Get user by username (case-insensitive)
 * @param {string} username - Username to search for
 * @returns {Object|null} User object or null if not found
 */
export const getUserByUsername = (username) => {
  if (!username || typeof username !== "string") return null;
  const key = username.toLowerCase();
  return mockUsers[key] || null;
};

/**
 * Get user by ID
 * @param {string} userId - User ID to search for
 * @returns {Object|null} User object or null if not found
 */
export const getUserById = (userId) => {
  if (!userId || typeof userId !== "string") return null;
  return Object.values(mockUsers).find((user) => user.id === userId) || null;
};

/**
 * Get all users
 * @returns {Object[]} Array of all user objects
 */
export const getAllUsers = () => {
  return Object.values(mockUsers);
};
